
  <mat-toolbar class="toolbar">
        <span class="toolbar-text">{{data.type}}</span>
      <button mat-icon-button aria-label="close dialog" mat-dialog-close class="margin-auto">
        <mat-icon>close</mat-icon>
      </button>
  </mat-toolbar>
  <div class="alignPos">
    <div *ngIf="data.mess" style="margin-left: 22px; display: inline-block; font-size: 16px;" [innerHTML]="data.mess"></div>
    <span *ngIf="data.download" style="cursor: pointer; float: right; margin-right: 10px;" (click)="downloadFiles()"><img alt="img"
      src="./assets/Download.svg">
    <span
      style="font-weight: bold; padding-left: 7px;vertical-align: text-top; font-size: 12px; line-height: 10px; color: #0D8390;">
      Download Config Templates</span>
    </span>
    <div *ngIf="data.estimatedTime"
      style="margin-left: 22px; display: block; font-size: 12px; font-style: italic;font-weight: 800;"
      [innerHTML]="data.estimatedTime"></div>
    <div *ngIf="data.compare" style="margin-left: 22px; margin-top: 25px; font-size: 16px;">
      <div class="content" style="margin: 10px 0px 35px;">
        <label style="font-size: 12px; line-height: 30px;">Please select the cloud comparison method<span style="color: red;">*</span></label>
        <mat-radio-group class="radio" aria-label="Select an option" [(ngModel)]="compareType" name="compareType">
          <mat-radio-button value="File">File To Instance Comparison</mat-radio-button>
          <mat-radio-button value="Instance">Instance To Instance Comparison</mat-radio-button>
        </mat-radio-group>        
      </div>  
    </div>
  </div>
  <div *ngIf="data.cloudExtract && !data.reportStatus" style="margin-left: 15px;font-size: 12px;font-weight: 500;font-style: italic;position:relative;top:-15px">
    <span style="font-style: normal;"> Unable to fetch Parameters values from cloud instance. For this step, <b>Please see the prerequisites listed below.</b></span> 
    <span> 
      <ul style="margin-top: 5px">
        <li>Verify that the Confighub.catalog package is present in the chosen instance.</li>
        <li>Ensure valid credentials are configured in uipath orchestrator asset for the selected instance.</li>
        <li>Ensure a stable Internet connection.</li>
      </ul>
    </span>
  </div>
  <div [ngClass]="{'action' : data.cloudExtract==true && data.reportStatus==false}" style="clear: both;">
    <div class="buttonS" *ngIf="!data.compare">
      <button mat-flat-button class="okBtn" (click)="onClickOk('ok')"> Close </button>
    </div>
    <div class="buttonS compareBtn" *ngIf="data.compare" >
      <button mat-flat-button class="okBtn" (click)="onClickOk('cancel')"> Cancel </button>
    </div>
    <div class="buttonSR compareBtn" *ngIf="data.compare" >
      <button mat-flat-button class="yesBtn submitBtn" (click)="onClickOk(this.compareType)" [disabled]="compareType == null && compareType == undefined"> Submit </button>
    </div>
    <div class="buttonSR" *ngIf="data.transform">
      <button mat-flat-button class="yesBtn" (click)="onTransform()"> Yes, Continue </button>
    </div>
    <div class="buttonSR" *ngIf="data.cloudLoad">
      <button mat-flat-button class="yesBtn" (click)="onClickOk('yes')"> Yes, Continue </button>
    </div>
    <div class="buttonSR" *ngIf="data.upload">
      <button mat-flat-button class="yesBtn" (click)="onClickOk('upload')"> Upload Files </button>
    </div>
    <div class="buttonSR" *ngIf="data.cloudExtract">
      <button mat-flat-button class="yesBtn" [disabled]="!data.reportStatus" (click)="onClickOk('params')"> Add Parameters </button>
    </div>
  </div>

